import { getUniAdmins, editUniAdmin, addUniAdmin, removeUniAdmin } from '../api/admin';
import { getSupervisors, editSupervisor, addSupervisor, deleteSupervisor } from './supervisors';
import { getNewsSupervisors, editNewsSupervisor, addNewsSupervisor, deleteNewsSupervisor } from './newsSupervisors';
import { getOfficers, editOfficer, addOfficer, deleteOfficer } from './officers';

export const GET_ADMINS = 'GET_ADMINS';
export const EDIT_ADMIN = 'EDIT_ADMIN';
export const NEW_ADMIN = 'NEW_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';

function getAdmins(admins, error=null) {
    return {
        type: GET_ADMINS,
        admins,
        error
    }
}

export function handleGetAdmins(id) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await getUniAdmins(id, getState().authedUser.token);
            if(result){
                const admins = result.data.data;
                // dispatch(hideLoading())
                dispatch(getSupervisors(admins.filter(a => a.type === 1)));
                dispatch(getOfficers(admins.filter(a => a.type === 2)));
                dispatch(getNewsSupervisors(admins.filter(a => a.type === 3)));
                return dispatch(getAdmins(admins));
            }  else {
                // dispatch(hideLoading())
                return dispatch(getAdmins(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(getAdmins(null, error));
        }
    }
}

function editAdmin (admin, error=null) {
    return {
        type: EDIT_ADMIN,
        admin,
        error
    }
}

export function handleEditAdmin(uniId, adminId, data) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await editUniAdmin(uniId, adminId, data, getState().authedUser.token);
            if(result){
                const admin = result.data.data;
                switch(admin.type) {
                    case 1:
                        return dispatch(editSupervisor(admin));
                    case 2:
                        return dispatch(editOfficer(admin));
                    case 3 :
                        return dispatch(editNewsSupervisor(admin));
                    default:
                        return;
                }
                // dispatch(hideLoading())
            }  else {
                // dispatch(hideLoading())
                return dispatch(editAdmin(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(editAdmin(null, error));
        }
    }
}

function addAdmin (admin, error=null) {
    return {
        type: NEW_ADMIN,
        admin,
        error
    }
}

export function handleAddAdmin(uniId, data) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await addUniAdmin(uniId, data, getState().authedUser.token);
            if(result){
                const admin = result.data.data;
                // dispatch(hideLoading())
                switch(admin.type) {
                    case 1:
                        return dispatch(addSupervisor(admin));
                    case 2:
                        return dispatch(addOfficer(admin));
                    case 3 :
                        return dispatch(addNewsSupervisor(admin));
                    default:
                        return;
                }
            }  else {
                // dispatch(hideLoading())
                return dispatch(addAdmin(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(addAdmin(null, error));
        }
    }
}

// Delete Admin
function deleteAdmin (id, error=null) {
    return {
        type: DELETE_ADMIN,
        id,
        error
    }
}

export function handleDeleteAdmin(type, id) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await removeUniAdmin(id, getState().authedUser.token);
            if(result){
                switch(type) {
                    case 1:
                        return dispatch(deleteSupervisor(id));
                    case 2:
                        return dispatch(deleteOfficer(id));
                    case 3 :
                        return dispatch(deleteNewsSupervisor(id));
                    default:
                        return;
                }
            }  else {
                // dispatch(hideLoading())
                return dispatch(deleteAdmin(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(deleteAdmin(null, error));
        }
    }
}

// Emptying the admins store
export function restoreAdmins() {
    return async (dispatch) => {
        dispatch(getAdmins(null));
        dispatch(getSupervisors(null));
        dispatch(getNewsSupervisors(null));
        dispatch(getOfficers(null));
    }
}